import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import Ghdenglu from './views/Ghdenglu.vue'
import Yidongduanchongzhi from './views/Yidongduanchongzhi.vue'
import Xieyi from './views/Xieyi.vue'

import index from './views/nav1/index.vue'
import ruhuishenpi from './views/nav1/ruhuishenpi.vue'
import tuihuijilu from './views/nav1/tuihuijilu.vue'
import gonghuichengyuan from './views/nav1/gonghuichengyuan.vue'
import chengyuantongji from './views/nav1/chengyuantongji.vue'
import yingshoushuju from './views/nav1/yingshoushuju.vue'
import fangjiantongji from './views/nav1/fangjiantongji.vue'
let routes = [
	{
	    path: '/',
	    redirect: '/login', // 默认进入 /login（首次启动）
		hidden: true
	},
	{
	    path: '/ghdenglu',
	    name: 'ghdenglu', // 路由名称
	    component: Ghdenglu, // 新页面组件
		hidden: true
	},
	{
	    path: '/yidongduanchongzhi',
	    name: 'yidongduanchongzhi', // 路由名称
	    component: Yidongduanchongzhi, // 新页面组件
		hidden: true
	},
	{
	    path: '/xieyi',
	    name: 'xieyi', // 路由名称
	    component: Xieyi, // 新页面组件
		hidden: true
	},
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
	{
	    path: '/',
	    component: Home,
	    name: '公会信息',
	    leaf: true,//只有一个节点
	    iconCls: 'fa fa-user',//图标样式class
	    children: [
	        { path: '/index',id:'6', component: index, name: '公会信息' },
	        
	    ]
	},
	{
	    path: '/',
	    component: Home,
	    name: '入会审批',
	    leaf: true,//只有一个节点
	    iconCls: 'fa fa-user',//图标样式class
		id:2,
	    children: [
	        { path: '/ruhuishenpi',id:'6', component: ruhuishenpi, name: '入会审批' },
	        
	    ]
	},
	{
	    path: '/',
	    component: Home,
	    name: '退会记录',
	    leaf: true,//只有一个节点
	    iconCls: 'fa fa-user',//图标样式class
		id:3,
	    children: [
	        { path: '/tuihuijilu',id:'6', component: tuihuijilu, name: '退会记录' },
	        
	    ]
	},
	{
	    path: '/',
	    component: Home,
	    name: '公会成员',
	    leaf: true,//只有一个节点
	    iconCls: 'fa fa-user',//图标样式class
		id:4,
	    children: [
	        { path: '/gonghuichengyuan',id:'6', component: gonghuichengyuan, name: '公会成员' },
	        
	    ]
	},
	{
	    path: '/',
	    component: Home,
	    name: '成员统计',
	    leaf: true,//只有一个节点
	    iconCls: 'fa fa-user',//图标样式class
		id:5,
	    children: [
	        { path: '/chengyuantongji',id:'6', component: chengyuantongji, name: '成员统计' },
	        
	    ]
	},
	{
	    path: '/',
	    component: Home,
	    name: '营收数据',
	    leaf: true,//只有一个节点
	    iconCls: 'fa fa-user',//图标样式class
		id:6,
	    children: [
	        { path: '/yingshoushuju',id:'6', component: yingshoushuju, name: '营收数据' },
	        
	    ]
	},
	{
	    path: '/',
	    component: Home,
	    name: '房间统计',
	    leaf: true,//只有一个节点
	    iconCls: 'fa fa-user',//图标样式class
		id:7,
	    children: [
	        { path: '/fangjiantongji',id:'6', component: fangjiantongji, name: '房间统计' },
	        
	    ]
	},
	
    {
        path: '/',
        component: Home,
        name: '',
        hidden: true,
        children: [
            
        ]
    },

    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js